import { useState, useEffect } from 'react';
import { Card, Row, Col, Typography, Spin, Empty } from 'antd';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';

const { Title, Text } = Typography;

const SearchResultsPage = ({ isTabletOrMobile, loading }) => {
    const location = useLocation();
    const { searchQuery, searchResults } = location.state || {};
    const CategoryCard = ({ category }) => (
        <Col xs={12} sm={8} md={6} lg={6} key={category.id}>
            <a href={category.category_url} style={{ textDecoration: "none" }} target='_blank' rel="noreferrer">
                <Card
                    hoverable
                    className="text-center"
                    style={{
                        borderRadius: 12,
                        border: '1px solid #f0f0f0',
                        height: "100%",
                        transition: 'all 0.3s ease',
                        maxWidth: 220
                    }}
                    bodyStyle={{ padding: isTabletOrMobile ? '16px 12px' : '24px 16px' }}
                >
                    <img
                        style={{
                            width: '100%',
                            maxWidth: isTabletOrMobile ? 80 : 120,
                            height: isTabletOrMobile ? 80 : 120,
                            objectFit: 'cover',
                            marginBottom: 12
                        }}
                        src={category.image}
                        alt={category.category}
                    />
                    <Text style={{
                        fontSize: isTabletOrMobile ? 13 : 14,
                        fontWeight: 600,
                        color: '#333',
                        display: 'block'
                    }}>
                        {category.category}
                    </Text>
                </Card>
            </a>
        </Col>
    );

    const ProductCard = ({ product }) => (
        <Col xs={24} sm={12} md={8} lg={6} key={product.id}>
            <a href={product.product_url} style={{ textDecoration: "none" }} target='_blank' rel="noreferrer">
                <Card
                    hoverable
                    style={{
                        borderRadius: 12,
                        border: '1px solid #f0f0f0',
                        height: '100%',
                        transition: 'all 0.3s ease'
                    }}
                    bodyStyle={{ padding: isTabletOrMobile ? '12px' : '16px' }}
                >
                    <div style={{
                        width: '100%',
                        height: isTabletOrMobile ? 180 : 220,
                        backgroundColor: '#f5f5f5',
                        borderRadius: 8,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 12,
                        overflow: 'hidden'
                    }}>
                        <img
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                            src={product.image}
                            alt={product.product_name}
                        />
                    </div>
                    <div>
                        <Text strong style={{
                            fontSize: isTabletOrMobile ? 14 : 16,
                            color: '#333',
                            display: 'block',
                            marginBottom: 4
                        }}>
                            {product.product_name}
                        </Text>
                        <Text style={{
                            fontSize: isTabletOrMobile ? 12 : 13,
                            color: '#666',
                            display: 'block'
                        }}>
                            {product.description || product.product_name}
                        </Text>
                    </div>
                </Card>
            </a>
        </Col>
    );

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60vh'
            }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <>
            <div style={{
                padding: isTabletOrMobile ? '20px 16px' : '40px 80px',
                backgroundColor: '#fafafa',
                minHeight: '100vh'
            }}>
                {/* Header */}
                <div style={{ marginBottom: 32 }}>
                    <Title level={2} style={{
                        fontSize: isTabletOrMobile ? 24 : 32,
                        marginBottom: 8,
                        color: '#000'
                    }}>
                        Showing Results for <span style={{ color: '#1890ff' }}>{searchQuery}</span>
                    </Title>
                </div>

                {searchResults ? (
                    <>
                        {/* Categories Section */}
                        {searchResults.categories && searchResults.categories.length > 0 && (
                            <div style={{ marginBottom: 48 }}>
                                <Row gutter={[16, 16]}>
                                    {searchResults.categories.map(category => (
                                        <CategoryCard key={category.id} category={category} />
                                    ))}
                                </Row>
                            </div>
                        )}

                        {/* Products Section */}
                        {searchResults.products && searchResults.products.length > 0 && (
                            <div>
                                <Title level={3} style={{
                                    fontSize: isTabletOrMobile ? 20 : 24,
                                    marginBottom: 24,
                                    color: '#000'
                                }}>
                                    Products
                                </Title>
                                <Row gutter={[16, 16]}>
                                    {searchResults.products.map(product => (
                                        <ProductCard key={product.id} product={product} />
                                    ))}
                                </Row>
                            </div>
                        )}

                        {/* No Results */}
                        {(!searchResults.categories || searchResults.categories.length === 0) &&
                            (!searchResults.products || searchResults.products.length === 0) && (
                                <Empty
                                    description={`No results found for "${searchQuery}"`}
                                    style={{ marginTop: 60 }}
                                />
                            )}
                    </>
                ) : (
                    <Empty
                        description="Start searching to see results"
                        style={{ marginTop: 60 }}
                    />
                )}
            </div>

            <Footer />
        </>

    );
};

export default SearchResultsPage;